
export default {
    ANY_FEE: 'any',
    NO_FEE: 'none',
};
